export function checklistGrade(checklist) {
    let correct = [];
    for (let test of checklist) {
        try {
          if (document.getElementById("target").contentWindow.eval(test)) {
            // correct++;
            correct.push(true);
          } else {
            correct.push(false);
          }
        } catch (err) {
          console.log(err);
        }
      }
      return correct;
}